export class ShortcutsHistory {
	private size = 1;
	private stack: Array<{
		flagId?: string;
		lastDeletedItem?: any;
		undo(): void;
	}> = [];

	push({ undo, lastDeletedItem }: { undo(): void; lastDeletedItem: any }): void {
		this.stack.push({ undo, lastDeletedItem });
		this.stack = this.stack.slice(-1 * this.size);
	}

	pop = ():
		| {
				flagId?: string;
				lastDeletedItem?: any;
				undo(): void;
		  }
		| undefined => this.stack.pop();

	peek = (): {
		flagId?: string;
		lastDeletedItem?: any;
		undo(): void;
	} => this.stack.slice(-1)[0];

	reset = (): void => {
		this.stack = [];
	};
}
